<template id="app">
  <v-app>
    <!--CONTENEDOR QUE CONTIENE EL BOTON CON EL CUAL SE DESPLAZA HASTA EL INICIO DE LA PAGINA-->
    <div id="progress">
      <span id="progress-value"><v-icon color="#fff">mdi-chevron-up</v-icon></span>
    </div>
    <!--CONTENEDOR INICIAL DE LA PAGINA. CONTINEN ALGUNOS MENUS EXTRAS Y EL LOGO DE LA FACULTAD-->
    <div id="appContEnlaces" @mouseover="band = false">
      <!--IMAGEN QUE SE MUESTRA-->
      <div class="my-auto grlClase">
        <v-img @click="insertarRuta('/')" :src="img" alt="FAZ" width="110px" />
      </div>
      <v-spacer />
      <!--BOTON A DIFERENTES RUTAS (solo se muestra en pc)-->
      <div class="my-auto hidden-sm-and-down">
        <v-btn dark text @click="insertarRuta('/sitio-interes')">Sitios de Interés</v-btn>
        <v-btn dark text onClick="window.open('https://www.ujed.mx/')">Sobre la UJED</v-btn>
        <v-btn dark text @click="insertarRuta('/contacto')">Contáctanos</v-btn>
      </div>
      <!--CONTIENE LA LISTA DE LAS OPCIONES DEL CONTENEDOR SOLO QUE ESTE SE UTILIZA PARA LOS DISPOSITIVOS MOVILES-->
      <div class="hidden-md-and-up my-auto">
        <v-menu open-on-click offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="white" v-bind="attrs" v-on="on">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="appItemListaEnlaces" @click="insertarRuta('/sitio-interes')">
              <v-list-item-title>Sitios de Interés</v-list-item-title>
            </v-list-item>
            <v-list-item class="appItemListaEnlaces" onClick="window.open('https://www.ujed.mx/')">
              <v-list-item-title>Sobre la UJED</v-list-item-title>
            </v-list-item>
            <v-list-item class="appItemListaEnlaces" @click="insertarRuta('/contacto')">
              <v-list-item-title>Contáctanos</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <!--CONTENEDOR QUE CONTIENE LAS DIFERENTES OCPIONES (AppBar)-->
    <v-app-bar class="appBarPrincipal" color="#b11830">
      <v-spacer></v-spacer>
      <!--CONTENEDOR EN EL CUAL ESTAN LOS BOTONES QUE TE LLEVAN A OTRA RUTA (solo se muestra en pc)-->
      <div class="hidden-sm-and-down">
        <v-btn dark text @click="insertarRuta('/')" class="text-capitalize" rounded>Inicio</v-btn>
        <v-btn dark text @click="insertarRuta('/directorio')" class="text-capitalize" rounded>Directorio</v-btn>
        <v-menu open-on-hover offset-y rounded="lg">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text v-bind="attrs" v-on="on" class="text-capitalize" rounded
              @mouseover="band = false">
              Conocenos
              <v-icon size="15">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="itemCon in conocenos" :key="itemCon.ruta" @click="insertarRuta(itemCon.ruta)">
              <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">{{ itemCon.name }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu :value="band" offset-y rounded="lg">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text v-bind="attrs" v-on="on" class="text-capitalize" rounded
              @mouseover="band = true">
              Oferta Educativa
              <v-icon size="15">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-menu open-on-hover offset-x rounded="lg" v-for="itemOE in ofertaEducativa" :key="itemOE.name">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-bind="attrs" v-on="on" @click="insertarRuta(itemOE.ruta)"
                  v-if="itemOE.name == 'Licenciaturas'">
                  <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">{{ itemOE.name }}</v-btn>
                </v-list-item>
                <v-list-item @click="irPosgrado()" v-else>
                  <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">{{ itemOE.name }}</v-btn>
                </v-list-item>
              </template>
              <v-list dense>
                <v-list-item v-for="lic in licenciaturas" :key="lic.name" v-if="itemOE.name == 'Licenciaturas'"
                  @click="insertarRuta(lic.ruta)">
                  <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">{{ lic.name }}</v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list>
        </v-menu>
        <v-menu open-on-hover offset-y rounded="lg">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text v-bind="attrs" v-on="on" class="text-capitalize" rounded
              @mouseover="band = false">
              Aspirantes
              <v-icon size="15">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="insertarRuta('/aspirantes/admision')">
              <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">Proceso de Admisión</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu open-on-hover offset-y rounded="lg">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text v-bind="attrs" v-on="on" class="text-capitalize" rounded>
              Vinculación
              <v-icon size="15">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="itemVin in vinculacion" :key="itemVin.ruta" @click="insertarRuta(itemVin.ruta)">
              <v-btn text class="text-capitalize" id="appOpcionesBotonBar" width="100%">{{ itemVin.name }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!--CONTENEDOR QUE TIENE UN BOTON QUE ACTIVA LA LISTA DE OPCIONES (solo se muestra en dispositivos moviles)-->
      <div class="hidden-md-and-up my-auto">
        <v-btn icon dark @click.stop="mostrarLista = !mostrarLista">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <!--LISTA QUE CONTIENE LAS DIFERENTES OPCIONES A NAVEGAR (solo se puede activar estando en dispositvos moviles)-->
    <div v-show="mostrarLista">
      <v-list>
        <v-list-item @click="insertarRuta('/'); mostrarLista = false">
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>
        <v-list-group v-for="item in items" :key="item.title" v-model="item.active" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="child in item.items" :key="child.title"
            @click="insertarRuta(child.ruta); mostrarLista = false" v-if="child.title != 'Posgrados'">
            <v-list-item-content style="margin-left: -15%;">
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
    <!--CONTENEDOR QUE MUESTRA LA RUTA QUE SE QUIERA VISUALIZAR (por defecto se visualiza la de inicio)-->
    <div @mouseover="band = false;">
      <v-main>
        <router-view />
      </v-main>
    </div>
    <!--PIE DE PAGINA-->
    <v-footer id="appContFooter" color="#b11830">
      <v-container>
        <div class="appContenedorPrincipalFooter">
          <!--OPCIONES IZQUIERDA (no se muestra en dispositivos moviles)-->
          <div id="appBoxFooterIzq" class="hidden-sm-and-down">
            <h3 @click="insertarRuta('/directorio')">Directorio</h3>
            <h3 onClick="window.open('/pdfs/22.pdf')">Biblioteca</h3>
            <h3 onClick="window.open('/pdfs/18.pdf')">Investigación</h3>
            <h3 @click="insertarRuta('/conocenos/publicaciones')">Publicaciones</h3>
            <h3 @click="insertarRuta('/sitio-interes')">Sitio de interés</h3>
          </div>
          <!--OPCIONES CENTRALES-->
          <div id="appBoxFooterCen">
            <div>
              <v-icon class="appRedesSociales" size="40" dark
                onClick="window.open('https://www.facebook.com/UJEDFAZ')">mdi-facebook</v-icon>
              <v-icon class="appRedesSociales" size="40" dark
                onClick="window.open('https://www.youtube.com/channel/UCvSC_Mfv3oW3fnfAUaJkgsQ')">mdi-youtube</v-icon>
              <v-icon class="appRedesSociales" size="40" dark
                onClick="window.open('https://wa.me/8717855170')">mdi-whatsapp</v-icon>
              <v-icon class="appRedesSociales" size="40" dark
                onClick="window.open('mailto:dep.faz.ujed@hotmail.com')">mdi-mail</v-icon>
            </div>
            <div>
              <p>Teléfono: (871) 785-51-70</p>
              <p>Carretera Gómez Palacio - Tlahualilo</p>
              <p>KM 32 Venecia, Durango, México.</p>
            </div>
          </div>
          <!--OPCIONES DERECHA (no se muestra en dispositivos moviles)-->
          <div id="appBoxFooterDer" class="hidden-sm-and-down">
            <h3 onClick="window.open('https://www.ujed.mx/')" target="_blank">UJED</h3>
            <h3 @click="insertarRuta('/contacto')" target="_blank">Ubicación</h3>
            <h3 onClick="window.open('/pdfs/18.pdf')" target="_blank">Privacidad</h3>
            <h3 onClick="window.open('http://faz.ujed.mx/jbotanico/index.html')">Jardín Botánico</h3>
            <h3 onClick="window.open('/pdfs/26.pdf')" target="_blank">Código de Ética</h3>
          </div>
        </div>
        <v-divider class="appDivider"></v-divider>
        <p class="text-center white--text">&copy; Derechos reservados | Facultad de Agricultura y Zootecnia 2024
        </p>
      </v-container>
    </v-footer>
  </v-app>
</template>
<script>
import './assets/stylesheets/main.css';

export default {
  name: 'App',
  data: () => ({
    band: false,
    mostrarLista: false,
    //Imagen del conenedor incial
    img: require('./assets/img/logofaz.png'),
    //Objeto que contiene las subrutas que se muestran en el boton "conocenos"
    conocenos: [
      {
        name: 'Misión y Visión',
        ruta: '/conocenos/mision-vision'
      },
      {
        name: 'Planta Academica',
        ruta: '/planta-academica'
      },
      {
        name: 'Marco Juridico',
        ruta: '/conocenos/marco-juridico'
      },
      {
        name: 'Publicaciones',
        ruta: '/conocenos/publicaciones'
      }
    ],
    //Objeto que contiene las subrutas que se muestran en el boton "Oferta Educativa"
    ofertaEducativa: [
      {
        name: 'Licenciaturas',
        ruta: '/programas'
      },
      {
        name: 'Posgrados',
        ruta: '/posgrados'
      }
    ],
    //Objeto que contiene las subrutas que se muestran en el boton "Licenciaturas"
    licenciaturas: [
      {
        name: 'Ing. Agrónomo Zootecnista',
        ruta: '/oferta-educativa/zootecnia'
      },
      {
        name: 'Ing. Agrónomo en Fitotecnia',
        ruta: '/oferta-educativa/fitotecnia'
      },
      {
        name: 'Ing. en Fritucultura',
        ruta: '/oferta-educativa/fruticultura'
      }
    ],
    //Objeto que contiene las subrutas que se muestran en el boton "Vinculacion"
    vinculacion: [
      {
        name: 'Bolsa de trabajo',
        ruta: '/vinculacion/bolsa-de-trabajo'
      },
      {
        name: 'Convenios',
        ruta: '/convenios'
      }
    ],
    //OBJETO QUE CONTIENE LA LISTA DE LAS OPCIONES (se utiliza para los dispositivos moviles)
    items: [
      {
        items: [{ title: 'Organigrama', ruta: '/directorio' }],
        title: 'Directorio',
      },
      {
        items: [
          { title: 'Misión y Visión', ruta: '/conocenos/mision-vision' },
          { title: 'Planta Academica', ruta: '/conocenos/planta-academica' },
          { title: 'Marco Juridico', ruta: '/conocenos/marco-juridico' },
          { title: 'Publicaciones', ruta: '/conocenos/publicaciones' },
        ],
        title: 'Conocenos',
      },
      {
        items: [
          { title: 'Licenciaturas', ruta: '/programas' },
          { title: 'Posgrados', ruta: '/posgrados' },
        ],
        title: 'Oferta Educativa',
      },
      {
        items: [{ title: 'Proceso de admision', ruta: '/aspirantes/admision' }],
        title: 'Aspirantes',
      },
      {
        items: [
          { title: 'Bolsa de trabajo', ruta: '/vinculacion/bolsa-de-trabajo' },
          { title: 'Convenios', ruta: '/convenios' },
        ],
        title: 'Vinculacion',
      },
    ],
  }),
  //METODOS UTILIZADOS
  methods: {
    //Se utiliza para navegar por diferentes ruta (redirecciona a diferentes paginas)
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
    //Ir a la pagina de posgrados FAZ
    irPosgrado() {
      location.replace(window.location.protocol + "//" + window.location.host + "/Posgrado/");

    },
    //Calcular Scroll
    calcScroll() {
      let calcScrollValue = () => {
        let scrollProgress = document.getElementById("progress");
        let progressValue = document.getElementById("progress-value");
        let pos = document.documentElement.scrollTop;
        let calcHeight =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;
        let scrollValue = Math.round((pos * 100) / calcHeight);
        if (pos > 100) {
          scrollProgress.style.display = "grid";
        } else {
          scrollProgress.style.display = "none";
        }
        scrollProgress.addEventListener("click", () => {
          document.documentElement.scrollTop = 0;
        });
        scrollProgress.style.background = `conic-gradient(#03cc65 ${scrollValue}%, #d7d7d7 ${scrollValue}%)`;
      };
      window.onscroll = calcScrollValue;
      window.onload = calcScrollValue;
    }
  },
  //El metodo created() se ejecuta al ingresar a la página
  created() {
    this.calcScroll();
  },
};


</script>